exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".note-text-preview{font-size:13px;color:var(--gray-7);padding-right:12px;-webkit-user-select:text!important;-moz-user-select:text!important;-ms-user-select:text!important;user-select:text!important;cursor:text;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;width:calc(100% - 12px);overflow:hidden}.preview-comment{color:var(--text-color)}.note-text-preview-prompt{cursor:pointer;color:var(--primary-button)}.note-text-preview-prompt:hover{color:var(--primary-button-hover)}", ""]);

// exports
